<ng-container>
  <fin-loyalty-section-navigation [mobile]="true" />
  <div>
    <div
      class="grid-col-12 pr-large-b pr-medium-t padding-left-gutter padding-right-gutter grid-max-width center ng-star-inserted"
    >
      <div
        class="col-1-12 font-heading-2 nordic-blue-900-text text-icon-primary font-headline-small"
        data-testid="loyalty-view-page-title"
      >
        {{ pageTitle }}
      </div>
    </div>
    <div class="grid-col-12 grid-max-width padding-left-gutter padding-right-gutter center">
      <div class="col-1-12 md-col-1-3 dn-laptop-down">
        <fcom-plus-card *ngIf="showPlusCard" class="ms-xxlarge-b" />

        <fin-loyalty-section-navigation />

        <fin-announcement-card *ngIf="showAnnouncementCard" class="ms-xxlarge-t block" />

        <ng-content select="[contentLeft]" />
      </div>
      <div class="col-1-12 md-col-4-12">
        <ng-content />
      </div>
    </div>
    <div class="ms-large-t">
      <ng-content select="[benefitBanner]" />
    </div>
  </div>
</ng-container>
